import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Swiper, { Navigation } from 'swiper';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

Swiper.use([Navigation]);

class ImageSwiper extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        swiperIndex: 0
    }

    componentDidMount() {
        // eslint-disable-next-line consistent-this
        const that = this;

        new Swiper('#swiper3', {
            loop: true,
            navigation: {
                prevEl: '.prev3',
                nextEl: '.next3'
            },
            on: {
                slideChangeTransitionEnd () {
                    that.setState({
                        swiperIndex: this.realIndex
                    });
                }
            }
        });
    }

    getIndex = () => {
        const { swiperIndex } = this.state;

        return String(swiperIndex + 1).length === 1 ? `0${swiperIndex + 1}` : swiperIndex + 1;
    };

    render() {
        const { content } = this.props;
        const { swiperIndex } = this.state;

        return (
            <div className={styles.container}>
                <div className="swiper" id="swiper3">
                    <div className="swiper-wrapper">
                        {
                            content.map((item, index) => {
                                return (
                                    <div className="swiper-slide" key={index}>
                                        <div className={styles.swiperItem}>
                                            <a href={item.url} target="_blank" rel="noreferrer">
                                                <img src={formatImage(getThumbnail(item), 1000, 620)} alt={item.title} />
                                            </a>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <img className={`prev3 ${styles.prev3}`} src={require('../../assets/prev3.png')} alt="" />
                <img className={`next3 ${styles.next3}`} src={require('../../assets/next3.png')} alt="" />
                <div className={styles.text}>
                    <div className={styles.index}>
                        第<span>{this.getIndex()}</span>张
                    </div>
                    <div className={styles.content}>
                        <div className={styles.title}>
                            {content[swiperIndex].title}
                        </div>
                        <div className={styles.subTitle}>
                            {content[swiperIndex].summary}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImageSwiper;
